import { useEffect } from 'react';

/**
 * Custom hook to add scroll animations to elements
 * Elements with 'scroll-animate' class will animate when they come into view
 */
const useScrollAnimation = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animated');
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // Observe all elements with any scroll-animate variant class
        const animatedElements = document.querySelectorAll(
            '.scroll-animate, .scroll-animate-scale, .scroll-animate-fade, ' +
            '.scroll-animate-slide-left, .scroll-animate-slide-right, .scroll-animate-rotate'
        );
        animatedElements.forEach(el => observer.observe(el));

        // Cleanup
        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
};

export default useScrollAnimation;
